/**
 * Wire instructions calls for the secure link flow (/link/wire-instructions): vendor-service's @SecureLinkEndpoint
 * endpoints, authorized by the secure link session through its request() (Authorization: Bearer). Never sends a loan
 * id or token: the server takes the loan from the session.
 */
const BASE = '/api/v1/vendor/secure-link/wire';

export type SecureLinkRequest = <T>(path: string, init?: RequestInit) => Promise<T>;

export class WireInstructionsService {

  getWireInstructionsData(request: SecureLinkRequest) {
    return request(`${BASE}/data`).then(data => ({ data }));
  }

  /** Multipart: the form data as JSON plus the optional document. The browser sets the multipart Content-Type. */
  submitWireInstructions(request: SecureLinkRequest, formData: FormData) {
    return request(`${BASE}/submit`, { method: 'POST', body: formData });
  }
}
